import { css } from 'emotion';
import { animationTransition } from '@joykit/variables';

export namespace styles {
  export const container = css({
    width: '100%',
    // minHeight: '100%',
    opacity: 0,
    transition: animationTransition('opacity')
  });
}
